import strings from '../../../../Localization/Localization';

let scheduleDate = {
  fieldKey: "schedule_date",
  type: "date",
  label: strings.form.cart.transition.scheduleDelivery.scheduleDate.label,

  min: () => {
    let today = new Date();
    let year = String(today.getFullYear());
    let month = String(today.getMonth()+2).padStart(2, "0");
    let date = "01";
    return year+'-'+month+'-'+date
  },

  validators: [
    {
      id: 'assertEmpty',
      type: 'notEmptyOrNull',
      invalidFeedback: strings.form.cart.transition.scheduleDelivery.scheduleDate.invalid.assertEmpty,
      defaultValue: false
    },
  ]
}

export const form = {
  formKey: "scheduleDelivery",
  fields: [
    scheduleDate
  ]
}
